import { type PropsWithChildren as PWC, Suspense } from 'react';

import { Cover, Loader } from '@myphx-engineering/phx-design-system';

export const RootSuspenseBoundary = ({ children }: PWC) => (
    <Suspense
        fallback={
            <Cover visible>
                <Loader />
            </Cover>
        }
    >
        {children}
    </Suspense>
);
